 
import * as yup from 'yup';

export const RestPassVal2 = yup.object().shape({
  password: yup.string().min(5).required(),
  confirmpassword: yup.string()
    .oneOf([yup.ref('password')], 'Password must match')
    .required('Password must match'),
});